import type { ChecklistExecutionStep } from "./ChecklistExecutionStep"

export const describeChecklistExecutionStepValue = (
  step: Pick<
    ChecklistExecutionStep,
    | "status"
    | "responseType"
    | "notCompletedReason"
    | "yesNoValue"
    | "selectedOptionLabel"
    | "textValue"
    | "numberValue"
    | "dateTimeValue"
  >,
  t: (key: string) => string,
  fallbackCompletedLabel: string,
): string => {
  if (step.status === "NotCompleted") return step.notCompletedReason ?? ""

  switch (step.responseType) {
    case "YesNo":
      return step.yesNoValue ? t("general:label_yes") : t("general:label_no")
    case "MultipleChoice":
      return step.selectedOptionLabel ?? ""
    case "Text":
      return step.textValue ?? ""
    case "Number":
      return step.numberValue !== null && step.numberValue !== undefined ? String(step.numberValue) : ""
    case "DateTime":
      return step.dateTimeValue ?? ""
    default:
      return step.status === "Completed" ? fallbackCompletedLabel : ""
  }
}
